// extracted by mini-css-extract-plugin
module.exports = {"img":"Logo_img_mbfaq"};